var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPulseLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "trasparent",
      display: "block",
      shapeRendering: "auto"
    },
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20.5,
    width: 22,
    height: 59,
    fill: "#00206e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1.3157894736842106s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "2.799999999999997;20.5;20.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.2631578947368421s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1.3157894736842106s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "94.4;59;59",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.2631578947368421s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 20.5,
    width: 22,
    height: 59,
    fill: "#00206eA0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1.3157894736842106s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "7.224999999999994;20.5;20.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.13157894736842105s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1.3157894736842106s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "85.55000000000001;59;59",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.13157894736842105s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 20.5,
    width: 22,
    height: 59,
    fill: "#d1eaff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1.3157894736842106s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "7.224999999999994;20.5;20.5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1.3157894736842106s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "85.55000000000001;59;59",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseLoader);
export default __webpack_public_path__ + "static/media/pulse-loader.aec11576deeb45b53f530560f9a2b053.svg";
export { ForwardRef as ReactComponent };